import BaseConstraint from './BaseConstraint'

/**
 * the constraint, which is satisfied if all of constraints, specified in
 * constructor is satisfied
 */
export default class AllConstraint extends BaseConstraint {
  /**
   * create the constraint with specified constraints
   *
   * @param {Array} constraints     constraints to be checked
   */
  constructor (constraints) {
    super ({
      check () {
        return this.checkConstraints ()
      }
    })

    this.constraints = constraints
  }

  /**
   * checks whether all of constraints, specified in constructor is satisfied
   *
   * @return {boolean}      {@code true} if all of constraints, specified in
   *                        constructor is satisfied, {@code false} otherwise
   */
  checkConstraints () {
    return this.constraints.every (it => it.isSatisfied (this.user))
  }
}
